import type { ThemeOptions } from '@mui/material/styles';

export const shape: ThemeOptions['shape'] = {
    borderRadius: 8,
};